import React, { Fragment } from 'react';
import Content from '../shared/content';
import IconRenderer from '../shared/icon-renderer';
import useButtonBase from '../shared/use-button-base';
/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */
const useDefaultButton = ({
  analyticsContext,
  appearance,
  ariaLabel,
  ariaLabelledBy,
  autoFocus,
  buttonType,
  children,
  iconAfter,
  iconBefore,
  interactionName,
  isDisabled,
  isLoading = false,
  isSelected,
  onClick,
  onClickCapture,
  onKeyDownCapture,
  onKeyUpCapture,
  onMouseDownCapture,
  onMouseUpCapture,
  onPointerDownCapture,
  onPointerUpCapture,
  onTouchEndCapture,
  onTouchStartCapture,
  ref,
  shouldFitContainer,
  spacing,
  testId,
  UNSAFE_iconAfter_size,
  UNSAFE_iconBefore_size
}) => {
  const baseProps = useButtonBase({
    analyticsContext,
    appearance,
    autoFocus,
    ariaLabel,
    ariaLabelledBy,
    buttonType,
    children: /*#__PURE__*/React.createElement(Fragment, null, iconBefore && /*#__PURE__*/React.createElement(Content, {
      type: "icon",
      position: "before",
      isLoading: isLoading
    }, /*#__PURE__*/React.createElement(IconRenderer, {
      icon: iconBefore,
      size: UNSAFE_iconBefore_size
    })), children && /*#__PURE__*/React.createElement(Content, {
      isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/React.createElement(Content, {
      type: "icon",
      position: "after",
      isLoading: isLoading
    }, /*#__PURE__*/React.createElement(IconRenderer, {
      icon: iconAfter,
      size: UNSAFE_iconAfter_size
    }))),
    interactionName,
    isDisabled,
    isLoading,
    isSelected,
    onClick,
    onMouseDownCapture,
    onMouseUpCapture,
    onKeyDownCapture,
    onKeyUpCapture,
    onTouchStartCapture,
    onTouchEndCapture,
    onPointerDownCapture,
    onPointerUpCapture,
    onClickCapture,
    ref,
    shouldFitContainer,
    spacing,
    testId,
    hasIconBefore: Boolean(iconBefore),
    hasIconAfter: Boolean(iconAfter)
  });
  return baseProps;
};
export default useDefaultButton;